module.exports = __webpack_public_path__ + "img/howtoplay-04.ae0c123f.jpg";